import { Link } from "react-router-dom";
import { LegalPageLayout } from "@/components/shared/LegalPageLayout";
import { useSeo } from "@/components/shared/useSeo";

const UPDATED = "8 Ağustos 2026";

export default function KVKKAydinlatma() {
  useSeo({
    title: "KVKK Aydınlatma Metni | Sistem Elektrik ve Mühendislik",
    description: "Sistem Elektrik ve Mühendislik internet sitesi kişisel verilerin işlenmesine ilişkin KVKK aydınlatma metni.",
    canonical: "https://sistemmuhendislik.com/kvkk-aydinlatma-metni",
  });

  return (
    <LegalPageLayout
      eyebrow="KVKK"
      title="Kişisel Verilerin İşlenmesine İlişkin Aydınlatma Metni"
      description="İnternet sitemiz, iletişim kanallarımız ve proje talepleri kapsamında işlenen kişisel verilere ilişkin bilgilendirme."
      updatedAt={UPDATED}
    >
      <h2>1. Veri Sorumlusu</h2>
      <p>
        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu
        <strong> İsa Şeker</strong>'dir. Faaliyetler <strong>Sistem Elektrik ve Mühendislik</strong> markası altında yürütülmektedir.
      </p>
      <ul>
        <li><strong>Adres:</strong> Karacaoğlan Mah. 6219 Sk. No: 2 İç Kapı No: 1, Bornova / İzmir</li>
        <li><strong>E-posta:</strong> <a href="mailto:isa@sistemmuhendislik.com">isa@sistemmuhendislik.com</a></li>
        <li><strong>Telefon:</strong> <a href="tel:+905457649088">+90 545 764 9088</a></li>
      </ul>

      <h2>2. İşlenen Kişisel Veriler</h2>
      <p>İletişim şeklinize ve talebinizin niteliğine göre aşağıdaki veri kategorileri işlenir:</p>
      <ul>
        <li><strong>Kimlik bilgileri:</strong> ad ve soyad,</li>
        <li><strong>İletişim bilgileri:</strong> telefon numarası ve e-posta adresi,</li>
        <li><strong>İş ve talep bilgileri:</strong> varsa firma adı ve seçilen hizmet türü ile proje açıklaması/mesaj alanında tarafınızca paylaşılan bilgiler,</li>
        <li><strong>Teknik işlem bilgileri:</strong> internet sitesinin sunulması ve güvenliği kapsamında barındırma/form altyapısında oluşabilen IP, bağlantı, erişim, hata ve güvenlik kayıtları.</li>
      </ul>
      <p>İletişim formu ve serbest metin alanlarında özel nitelikli kişisel veri paylaşmamanızı rica ederiz.</p>

      <h2>3. İşleme Amaçları ve Hukuki Sebepler</h2>
      <ul>
        <li>
          <strong>Genel bilgi ve iletişim talepleri:</strong> Ad-soyad, telefon, e-posta ve tarafınızca iletilen talep bilgileri; talebin alınması, değerlendirilmesi ve yanıtlanması amacıyla, temel hak ve özgürlüklerinize zarar vermemek kaydıyla veri sorumlusunun meşru menfaati hukuki sebebine dayanılarak (KVKK m.5/2-f) işlenir.
        </li>
        <li>
          <strong>Teklif/proje ve sözleşme öncesi süreç:</strong> Talebiniz sizin taraf olacağınız bir sözleşmenin kurulması veya ifasıyla doğrudan ilgiliyse ad-soyad, iletişim, varsa firma/hizmet türü ve proje bilgileri KVKK m.5/2-c kapsamında işlenir. Bir şirket veya kuruluş adına iletişim kurmanız hâlinde ise iletişim ve talep bilgileriniz, iş ilişkisinin ve iletişimin ölçülü biçimde yürütülmesi amacıyla temel hak ve özgürlüklerinize zarar vermemek kaydıyla meşru menfaat hukuki sebebine (KVKK m.5/2-f) dayanılarak işlenebilir.
        </li>
        <li>
          <strong>Hukuki ve mali yükümlülükler:</strong> Mevzuat gereği tutulması veya yetkili makamlara sunulması gereken kayıtlar, veri sorumlusunun hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması hukuki sebebine dayanılarak (KVKK m.5/2-ç) işlenir.
        </li>
        <li>
          <strong>Hakların korunması ve uyuşmazlıklar:</strong> Bir hakkın tesisi, kullanılması veya korunması için gerekli olan iletişim ve işlem kayıtları KVKK m.5/2-e kapsamında işlenir.
        </li>
        <li>
          <strong>Site ve sistem güvenliği:</strong> Sınırlı teknik işlem bilgileri; internet sitesinin güvenli ve düzenli sunulması, kötüye kullanımın önlenmesi ve teknik sorunların giderilmesi amacıyla meşru menfaat hukuki sebebine dayanılarak (KVKK m.5/2-f) işlenir.
        </li>
      </ul>

      <h2>4. Kişisel Verilerin Toplanma Yöntemi</h2>
      <p>
        Kişisel veriler; internet sitesindeki iletişim formu, e-posta ve tarafınızca tercih edilmesi hâlinde WhatsApp gibi elektronik kanallardan tamamen veya kısmen otomatik yollarla elde edilir. Telefon veya diğer doğrudan iletişim kanallarında paylaşılan bilgilerin belirli kriterlere göre yapılandırılmış bir kayıt sistemine kaydedilmesi hâlinde veriler, veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yöntemle elde edilir.
      </p>

      <h2>5. Kişisel Verilerin Aktarılması</h2>
      <p>
        Kişisel veriler, yukarıdaki amaçlarla sınırlı ve ölçülü olmak üzere; internet sitesi barındırma ve form altyapısı sağlayıcısına, iletişimin yürütülmesi için kullanılan e-posta ve bilgi teknolojisi hizmet sağlayıcılarına, WhatsApp kanalını sizin tercih etmeniz hâlinde WhatsApp/Meta altyapısına, somut olay gerektiriyorsa hukuki/mali danışmanlara ve kanunen yetkili kamu kurum ve kuruluşlarına aktarılır.
      </p>
      <p>
        Site <strong>Netlify</strong> altyapısında barındırılmakta ve iletişim formu <strong>Netlify Forms</strong> üzerinden işlenmektedir. Ayrıca sayfalarda Google Fonts ve Unsplash gibi yurt dışı kaynaklı teknik/içerik sağlayıcılarına doğrudan tarayıcı bağlantıları bulunmaktadır; WhatsApp kanalının tercih edilmesi hâlinde WhatsApp/Meta altyapısı da devreye girer. Bu yapı nedeniyle iletişim formu verileri, iletişim verileri ve/veya bağlantı verileri bakımından yurt dışına kişisel veri aktarımı ortaya çıkabilir. Yurt dışına aktarımın hukuka uygunluğu için KVKK'nın 9. maddesinde öngörülen şartlardan uygun olanının ayrıca tesis edilmesi gerekir; yalnızca bu aydınlatma metninin yayımlanması bir yurt dışı aktarım mekanizması oluşturmaz.
      </p>

      <h2>6. Saklama Süresi</h2>
      <p>
        Bir iş veya sözleşme ilişkisine dönüşmeyen iletişim ve proje talepleri, talebin sonuçlanmasından itibaren <strong>1 yıl</strong> saklanır; sürenin sonunda başka bir hukuki saklama sebebi yoksa silinir, yok edilir veya anonim hâle getirilir.
      </p>
      <p>
        Talebin bir sözleşme, ticari ilişki, hukuki yükümlülük veya uyuşmazlıkla bağlantılı hâle gelmesi durumunda ilgili kayıtlar, uygulanabilir mevzuatın gerektirdiği saklama ve zamanaşımı süreleri boyunca muhafaza edilir.
      </p>

      <h2>7. KVKK Kapsamındaki Haklarınız</h2>
      <p>KVKK'nın 11. maddesi kapsamında veri sorumlusuna başvurarak;</p>
      <ul>
        <li>kişisel verilerinizin işlenip işlenmediğini öğrenme ve işlenmişse bilgi talep etme,</li>
        <li>işlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme,</li>
        <li>yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme,</li>
        <li>eksik veya yanlış işlenmiş verilerin düzeltilmesini isteme,</li>
        <li>KVKK'daki şartlar çerçevesinde silme veya yok etme talep etme ve bu işlemlerin verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
        <li>münhasıran otomatik sistemler vasıtasıyla analiz sonucu aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
        <li>kanuna aykırı işleme nedeniyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
      </ul>
      <p>haklarına sahipsiniz.</p>

      <h2>8. Başvuru Usulü</h2>
      <p>
        KVKK kapsamındaki taleplerinizi ıslak imzalı yazılı başvuru ile yukarıdaki iş yeri adresine iletebilirsiniz. Mevzuatta öngörülen diğer elektronik başvuru yöntemleri de ilgili yöntemin şartları sağlanarak kullanılabilir.
      </p>
      <p>
        <a href="mailto:isa@sistemmuhendislik.com">isa@sistemmuhendislik.com</a> adresi genel iletişim için kullanılabilir. KVKK başvurusunun sıradan e-posta ile yapılması hâlinde, mevzuattaki elektronik başvuru yöntemini karşılaması için başvurunun ilgili kişi tarafından veri sorumlusuna daha önce bildirilmiş ve veri sorumlusunun sisteminde kayıtlı bulunan e-posta adresinden gönderilmesi gerekir.
      </p>
      <p>
        Başvuruda ad-soyad; Türkiye Cumhuriyeti vatandaşları için T.C. kimlik numarası; yabancılar için uyruğu, pasaport numarası veya varsa kimlik numarası; tebligata esas yerleşim yeri veya iş yeri adresi; varsa bildirime esas e-posta adresi, telefon ve faks numarası ile talep konusu bulunmalıdır. Yazılı başvuruda imza da bulunmalıdır. Talebe ilişkin bilgi ve belgeler varsa başvuruya eklenmelidir.
      </p>
      <p>
        Usulüne uygun başvurular, talebin niteliğine göre en kısa sürede ve en geç 30 gün içinde sonuçlandırılır.
      </p>

      <div className="legal-note">
        İnternet sitesinin genel veri işleme yaklaşımı için <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>'nı, çerezler hakkında bilgi için <Link to="/cerez-politikasi">Çerez Politikası</Link>'nı inceleyebilirsiniz.
      </div>
    </LegalPageLayout>
  );
}
